<mat-card>
  <mat-card-content class="!flex flex-col gap-[24px] justify-center items-center">
    <img class="lt-md:!hidden flex-[180px] max-w-[180px]" src="/assets/img/invitations.svg" />
    <div>
      {{ '+INVITATIONS.INVITATIONS.INVITATION_CREATED' | translate }}
    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <button
      data-at-close
      mat-raised-button
      color="primary"
      gtm="onClose"
      gtmCategory="newInvitationCreatedModal"
      (click)="closed.emit()"
    >
      {{ 'GENERAL.BUTTON.CLOSE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
